import { EmployeeRelativesState } from "../../EmployeeServiceState";
import { FullFormAction } from "../../../Engine/Core/Store/FullFormAction";

import { EmployeeRelativesActionType } from "./EmployeeRelativesAction";

export function employeeRelativesReducer(
    state: EmployeeRelativesState | undefined,
    action: FullFormAction
): EmployeeRelativesState | undefined {
    let nextState = state;

    if (action.type === EmployeeRelativesActionType.CompleteLoading) {
        nextState = {
            ...state,
            [action.payload.path]: {
                ...state?.[action.payload.path],
                selectedRelative: state?.[action.payload.path]?.selectedRelative ?? null,
                relatives: action.payload.relatives,
            },
        };
    }
    if (action.type === EmployeeRelativesActionType.SelectRelative) {
        nextState = {
            ...state,
            [action.payload.path]: {
                ...state?.[action.payload.path],
                selectedRelative: action.payload.relative,
                relatives: state?.[action.payload.path]?.relatives ?? [],
            },
        };
    }
    if (action.type === EmployeeRelativesActionType.InsertAddedRelative) {
        nextState = {
            ...state,
            [action.payload.path]: {
                ...state?.[action.payload.path],
                selectedRelative: action.payload.relative,
                relatives: [action.payload.relative].concat(state?.[action.payload.path]?.relatives ?? []),
            },
        };
    }

    return nextState;
}
